import { render, staticRenderFns } from "./sIdentify.vue?vue&type=template&id=54137a20&scoped=true"
import script from "./sIdentify.vue?vue&type=script&lang=js"
export * from "./sIdentify.vue?vue&type=script&lang=js"
import style0 from "./sIdentify.vue?vue&type=style&index=0&id=54137a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54137a20",
  null
  
)

export default component.exports